import Box from "@mui/material/Box";
import LinearProgress from "@mui/material/LinearProgress";
import { TASK_ALERT_PROGRESS_TRACK_BG } from "../../utils/colors";

//eslint-disable-next-line
export { TASK_ALERT_PROGRESS_TRACK_BG };

//eslint-disable-next-line
export const taskAlertLoaderProgressSx = {
  "& .MuiLinearProgress-root": {
    height: 6,
    borderRadius: 999,
    backgroundColor: TASK_ALERT_PROGRESS_TRACK_BG,
  },
  "& .MuiLinearProgress-bar": {
    borderRadius: 999,
  },
};

const PROGRESS_COLORS = {
  success: "success.main",
  error: "error.main",
  warning: "warning.main",
  inProgress: "text.primary",
  pending: "text.disabled",
};

/**
 * Thin progress bar styled for task alert cards.
 */
const TaskAlertProgress = ({
  value = 0,
  status = "inProgress",
  className,
  sx = {},
}) => {
  const barColor =
    status === "success"
      ? PROGRESS_COLORS.success
      : status === "error"
        ? PROGRESS_COLORS.error
        : status === "warning"
          ? PROGRESS_COLORS.warning
          : status === "pending"
            ? PROGRESS_COLORS.pending
            : PROGRESS_COLORS.inProgress;

  return (
    <Box className={className} sx={{ width: "100%", ...sx }}>
      <LinearProgress
        variant="determinate"
        value={Math.min(Math.max(value, 0), 100)}
        sx={{
          height: 6,
          borderRadius: 999,
          backgroundColor: TASK_ALERT_PROGRESS_TRACK_BG,
          "& .MuiLinearProgress-bar": {
            borderRadius: 999,
            backgroundColor: barColor,
            transition: "transform 0.5s ease-out",
          },
        }}
      />
    </Box>
  );
};

export default TaskAlertProgress;
